<app-app-header></app-app-header>
<div class="minimal-height">
  <router-outlet></router-outlet>
</div>
<app-app-footer></app-app-footer>
<p-toast></p-toast>
<p-toast key="headless" position="bottom-center" class="w-auto!">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="bg-gray-800 rounded-full text-white text-center text-white py-2 px-4 center-all gap-2 text-sm font-bold">
      <i class="fa  fa-check-circle text-green-400 font-light"></i> {{ message.summary }}
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog></p-confirmDialog>
@if (showChunkLoader()) {
  <span class="w-[140px] left-1/2 translate-z-[-50px] z-[100000] fixed bottom-10 px-4 py-2 bg-black/80 text-white rounded-full flex gap-2">
  <span><i class="fa fa-spinner animate-spin"></i></span>Loading...</span>
}
